import user from "./user";
import guest from "./guest";

export default {
    guest, user
}